import "./NightCards.css";

interface NightBottomCardsProps {
  parkingCardSrc: string;
  musicCardSrc: string;
}

export function NightBottomCards({ parkingCardSrc, musicCardSrc }: NightBottomCardsProps) {
  return (
    <section className="night-bottom-cards" aria-label="夜间桌面底部卡片">
      <article className="night-info-card night-info-card--parking" aria-label="极氪 E 创停车场">
        <img className="night-info-card__vector" src={parkingCardSrc} alt="" draggable={false} aria-hidden="true" />
      </article>

      <article className="night-info-card night-info-card--music" aria-label="A Moment Apart">
        <img className="night-info-card__vector" src={musicCardSrc} alt="" draggable={false} aria-hidden="true" />
      </article>
    </section>
  );
}
